'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useTracker } from '@lichtblick/tracker';
import { BaseFooter } from '../BaseFooter/BaseFooter';
import { getStaticFooterHref, STATIC_FOOTER_SECONDARY_LINKS } from '../BaseFooter/Static';
const openUsercentricsSecondLayer = (event)=>{
    event.preventDefault();
    event.stopPropagation();
    window.__ucCmp?.showSecondLayer();
};
export const SecondaryNavigation = ({ hasLogo })=>{
    const { trackCustomEvent } = useTracker();
    const footerLinks = STATIC_FOOTER_SECONDARY_LINKS.map((item)=>({
            href: getStaticFooterHref(item.href),
            icon: item.icon,
            label: item.label,
            onClick (e) {
                trackCustomEvent(item.tracking);
                if (item.href === '#uc-central-modal-show') {
                    openUsercentricsSecondLayer(e);
                }
                item.onClick?.(e);
            }
        }));
    return /*#__PURE__*/ _jsx(BaseFooter, {
        hasLogo: hasLogo,
        links: footerLinks
    });
};

//# sourceMappingURL=SecondaryNavigation.js.map